import React from 'react';
import Footer from '../main-components/Footer';
import Header from '../main-components/Header';
import AboutBanner from './sub-component/about/About_banner';
import AboutMain from './sub-component/about/About_main';
import { Helmet } from 'react-helmet';

export default function About() {
  return (
    <>
     <Helmet>
                <meta charSet="utf-8" />
                <title>Best Construction Company in Delhi & Gurgaon. Jain Developers</title>
<meta name="description" content="Best Home Construction Companies in Delhi NCR & Gurgaon. MCG MCD map sanction, liaison service & Demolition in Delhi Gurgaon. | Jain Developers.
For more than 2 decades, Jain Developers has been Delhi's & Gurgaon renowned developers for its quality of constructions. Contact us for more details.
Jain Developers is trusted partner for property collaborations in Delhi NCR and Gurgaon. Specialize in turnkey solutions for residential and commercial projects.
Jain Developers is top Turnkey Construction developers in Delhi NCR and Gurgaon that handle entire construction process with your budget.
Jain Developers is leading in Collaboration and Turnkey developers in Delhi & Gurgaon. Do follow contact us for your dream project in your budget.
Explore our portfolio of completed turnkey and collaborative projects. From luxurious residential complexes to cutting-edge commercial spaces."/>
                <link rel="canonical" href="https://jaindevelopers.in/about" />
            </Helmet>
    <Header/>
    <AboutBanner/>
    <AboutMain/>
    <Footer/>
    </>
  )
}
